import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=989aeca8&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=989aeca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989aeca8",
  null
  
)

export default component.exports